import { analytics, EVENT_NAMES } from 'services/Analytics/Analytics'
import type { PetAiWallOffer } from './petAiWall.schemas'
import type { PetCandidate } from './petCandidate'

export function getPetAiWallAnalyticsProps({
  sourcePetSpecies,
  sourceUploadSrc,
}: Pick<PetAiWallOffer, 'sourcePetSpecies' | 'sourceUploadSrc'>) {
  return {
    'Pet Type': sourcePetSpecies,
    'Pet Photo Upload Src': sourceUploadSrc,
  }
}

export function trackPetCandidateFound({
  photo,
  score,
  species,
  signals,
}: PetCandidate): void {
  analytics.trackOncePerId(EVENT_NAMES.CART_PET_CANDIDATE_FOUND, photo.uid, {
    ...getPetAiWallAnalyticsProps({
      sourcePetSpecies: species,
      sourceUploadSrc: photo.uploadSrc,
    }),
    Score: score,
    'Pet Detection Score': signals.detectionScore,
    'Pet Area': signals.area,
    'Has People': signals.hasPeople,
    'Pet Short Side Px': signals.shortSidePx,
  })
}
